export enum ProductType {
    PREMIUM = "PREMIUM",
    BASE = "BASE",
    TEST = "TEST",
    PAID_TEST = "PAID_TEST",
    ADDON = "ADDON",
    FOR_LAWYER = "FOR_LAWYER",
    FOR_OTHER = "FOR_OTHER",
    VARIANT = "VARIANT"
}

/**
 * @example ```json
    {
        "magicNumber": "A3DK1O",
        "productType": "PREMIUM"
    }
```
 */
export default interface ProductPropertiesRelated {
    magicNumber: string,
    productType: ProductType,
    title?: string
}

